import React from 'react'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import RawListItem from '@mui/material/ListItem'
import {alpha} from '@mui/material/styles'
import {useTranslation} from 'react-i18next'
import {useSideMenuContext} from 'context/SideMenuContext'

const ListItem = ({page, onClick, selected}) => {
    const {t} = useTranslation()
    const {open} = useSideMenuContext()

    return (
        <RawListItem disablePadding sx={{display: 'block', padding: '2px 10px'}}>
            <ListItemButton
                selected={selected}
                sx={{
                    padding: 0,
                    borderRadius: 2,
                    minHeight: 44,
                    justifyContent: open ? 'flex-start' : 'center',
                    px: open ? 2 : 1.25,
                    color: (theme) =>
                        selected ? theme.palette.primary.main : theme.palette.text.secondary,
                    transition: (theme) =>
                        theme.transitions.create(['background-color', 'color'], {
                            duration: theme.transitions.duration.shortest,
                        }),
                    '&:hover': {
                        backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.08),
                    },
                    '&.Mui-selected': {
                        backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.12),
                        '&:hover': {
                            backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.18),
                        },
                    },
                }}
                onClick={onClick}>
                <ListItemIcon
                    sx={{
                        minWidth: 0,
                        marginInlineEnd: open ? 2 : 0,
                        justifyContent: 'center',
                        color: 'inherit',
                        transition: (theme) =>
                            theme.transitions.create(['margin'], {
                                duration: theme.transitions.duration.shortest,
                            }),
                    }}>
                    {page?.icon}
                </ListItemIcon>
                <ListItemText
                    primary={t(`side_menu.${page?.text}`)}
                    sx={{
                        opacity: open ? 1 : 0,
                        transition: 'opacity 120ms ease',
                        '.MuiListItemText-primary': {
                            fontWeight: selected ? 600 : 500,
                        },
                    }}
                />
            </ListItemButton>
        </RawListItem>
    )
}

export default ListItem
